import type {PhrasingContent} from 'mdast'

import {setOfAll} from '../../utils'

export const phrasingContentNodeTypes = setOfAll<
  Exclude<PhrasingContent['type'], 'inlinemath' | 'displaymath' | 'raw'>
>()(
  'break',
  'delete',
  'emphasis',
  'footnoteReference',
  'html',
  'image',
  'imageReference',
  'inlineCode',
  'link',
  'linkReference',
  'strong',
  'text',
  'delimiter',
)
